import { ThemeType } from '@becreatives/becreatives-ui';
import { LocalStorage } from 'src/services/LocalStorage';

const getActiveTheme = (): ThemeType => {
  return LocalStorage.get<ThemeType>('app-theme') || 'light';
};

export { getActiveTheme };
